import * as moment from "moment";
import * as React from "react";
import * as Constants from "../../core/constants";
import { ITranslationProps, translateComponent } from "../../helpers/translation";
import IMessageHeader from "../../types/IMessageHeader";
import IRecipient from "../../types/IRecipient";

interface IRecipientRowProps extends ITranslationProps {
    message: IMessageHeader;
    recipient: IRecipient;
    onRowClick: () => void;
}

function RecipientRow(p: IRecipientRowProps) {

    let recipient = "";
    let sentTime = "";
    let responseText = "";
    const responseTime = p.recipient.responseDateTime;
    let deliveryReceiptTime = "";

    switch (p.message.messageType) {
        case Constants.MESSAGE_TYPE_EMAIL:
            recipient = p.recipient.to;
            sentTime = p.recipient.sentDateTime;
            responseText = p.recipient.responseMessage;
            break;

        case Constants.MESSAGE_TYPE_PUSH:
            sentTime = p.recipient.sentDateTime;
            responseText = p.recipient.responseMessage;
            break;

        case Constants.MESSAGE_TYPE_SMS:
            recipient = p.recipient.phoneNumber;
            sentTime = p.recipient.sentDateTime;
            responseText = p.recipient.responseMessage;
            deliveryReceiptTime = p.recipient.deliveryReceiptDateTime;
            break;

        case Constants.MESSAGE_TYPE_VOICE:
            recipient = p.recipient.phoneNumber;
            sentTime = p.recipient.startTime;
            responseText = p.recipient.digitsDialed ? p.recipient.digitsDialed.split("|").join(", ") : "";
            break;
    }

    return (
        <tr onClick={p.onRowClick} className="recipient-row" title={p.t("Global.ClickForDetails")}>
            {p.message.messageType !== Constants.MESSAGE_TYPE_PUSH &&
                <td>{recipient}</td>
            }

            <td>{getFormattedDate(sentTime)}</td>

            <td>{truncate(responseText)}</td>

            {p.message.messageType !== Constants.MESSAGE_TYPE_VOICE &&
                <td>{getFormattedDate(responseTime)}</td>
            }

            {p.message.messageType === Constants.MESSAGE_TYPE_SMS &&
                <td>{getFormattedDate(deliveryReceiptTime)}</td>
            }

            {p.message.messageType === Constants.MESSAGE_TYPE_EMAIL &&
                <td>{p.recipient.bounced ? p.t("Global.Yes") : p.t("Global.No")}</td>
            }

            {p.message.messageType === Constants.MESSAGE_TYPE_VOICE &&
                <td>{p.recipient.machineDetection}</td>
            }
        </tr>
    );

    function getFormattedDate(dateValue: string) {
        if (!dateValue) { return dateValue; }
        return moment(dateValue).format(Constants.MOMENT_FORMAT_DATETIME);
    }

    function truncate(text: string) {
        if (text && text.length > 50) {
            return text.substr(0, 50) + "...";
        }
        return text;
    }


}

export default translateComponent(RecipientRow);



// WEBPACK FOOTER //
// ./src/components/MessageDetail/RecipientRow.tsx